import React from 'react'
import classNames from 'classnames'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
}
interface IList {
    id: string
    allowDelete?: boolean
    customItemsClasses?: string
    children?: React.ReactNode
    disabled?: boolean
    customClasses?: string
    items?: any[]
    header?: string
    subHeader?: string
    onChange?: (items: any[]) => void
}

const List: React.FC<IList> = ({
    id,
    allowDelete,
    customItemsClasses,
    children,
    disabled = false,
    customClasses,
    items,
    header,
    subHeader,
    onChange = () => null,
    ...otherProps
}) => {
    const onDragEnd = (result) => {
        if (!result.destination) {
            return
        }
        if (result.destination.index === result.source.index) {
            return
        }
        const reorderedItems = reorder(items, result.source.index, result.destination.index)
        onChange(reorderedItems)
    }

    return (
        <div className={classNames('list', customClasses)} {...otherProps}>
            {items?.length > 0 && (
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId='list'>
                        {(provided) => (
                            <div ref={provided.innerRef} {...provided.droppableProps}>
                                {children}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            )}
        </div>
    )
}

export default List
